(() => {
  document.querySelectorAll('[data-hero-stream]').forEach(hero => {
    const slides=[...hero.querySelectorAll('[data-hero-slide]')];
    const dots=[...hero.querySelectorAll('[data-hero-dot]')];
    if(slides.length<2)return;
    const duration=Number(hero.dataset.autoplay)||8000;
    hero.style.setProperty('--hero-duration',`${duration}ms`);
    let active=0,timer;
    const show=index=>{
      active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{const on=i===active;slide.classList.toggle('is-active',on);slide.setAttribute('aria-hidden',String(!on));});
      dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===active);const span=dot.querySelector('span');if(span){span.style.animation='none';span.offsetHeight;span.style.animation='';}});
      restart();
    };
    const restart=()=>{clearTimeout(timer);if(!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setTimeout(()=>show(active+1),duration);};
    hero.querySelector('[data-hero-prev]')?.addEventListener('click',()=>show(active-1));
    hero.querySelector('[data-hero-next]')?.addEventListener('click',()=>show(active+1));
    dots.forEach(dot=>dot.addEventListener('click',()=>show(Number(dot.dataset.heroDot))));
    hero.addEventListener('mouseenter',()=>clearTimeout(timer));hero.addEventListener('mouseleave',restart);
    restart();
  });
})();
